import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import { ActionInterface } from 'common/action.interface';
import { FaresTypes, FareInterface, OperationTypes } from './types';

// List Fares
export const listFaresRequest = (payload?: object) =>
  action(FaresTypes.LIST_FARES_REQUEST, payload);
// eslint-disable-next-line max-len
export const listFaresSuccess = (payload: {
  faresList: FareInterface[];
  totalCount: number;
}) => action(FaresTypes.LIST_FARES_SUCCESS, payload);
export const listFaresFailure = () => action(FaresTypes.LIST_FARES_FAILURE);

// List Fares
export const listCarFaresRequest = (payload?: object) =>
  action(FaresTypes.LIST_CAR_FARES_REQUEST, payload);
// eslint-disable-next-line max-len
export const listCarFaresSuccess = (payload: {
  carFaresList: FareInterface[];
  totalCount: number;
}) => action(FaresTypes.LIST_CAR_FARES_SUCCESS, payload);
export const listCarFaresFailure = () =>
  action(FaresTypes.LIST_CAR_FARES_FAILURE);

// Filter Fares
export const filterFaresRequest = (payload?: object) =>
  asyncAction(FaresTypes.FILTER_FARES_REQUEST, payload);
export const filterFaresSuccess = (payload: { totalCount: number }) =>
  action(FaresTypes.FILTER_FARES_SUCCESS, payload);
export const filterFaresFailure = () => action(FaresTypes.FILTER_FARES_FAILURE);

// Get Fare
export const getFareRequest = (payload: object) =>
  action(FaresTypes.GET_FARE_REQUEST, payload);
export const getFareSuccess = (payload: { fareData: FareInterface }) =>
  action(FaresTypes.GET_FARE_SUCCESS, payload);
export const getFareFailure = () => action(FaresTypes.GET_FARE_FAILURE);

// Create Fare
export const createFareRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) => action(FaresTypes.CREATE_FARE_REQUEST, payload, { dispatchOnSuccess });
export const createFareSuccess = (payload: { fareCreated: FareInterface }) =>
  action(FaresTypes.CREATE_FARE_SUCCESS, payload);
export const createFareFailure = () => action(FaresTypes.CREATE_FARE_FAILURE);

// Create Car Fare
export const createCarFareRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) => action(FaresTypes.CREATE_CAR_FARE_REQUEST, payload, { dispatchOnSuccess });
export const createCarFareSuccess = (payload: { fareCreated: FareInterface }) =>
  action(FaresTypes.CREATE_CAR_FARE_SUCCESS, payload);
export const createCarFareFailure = () =>
  action(FaresTypes.CREATE_CAR_FARE_FAILURE);

// Update Fare
export const updateFareRequest = (payload: object) =>
  action(FaresTypes.UPDATE_FARE_REQUEST, payload);
export const updateFareSuccess = (payload: { fareData: FareInterface }) =>
  action(FaresTypes.UPDATE_FARE_SUCCESS, payload);
export const updateFareFailure = () => action(FaresTypes.UPDATE_FARE_FAILURE);

// Update Car Fare
export const updateCarFareRequest = (payload: object) =>
  action(FaresTypes.UPDATE_CAR_FARE_REQUEST, payload);
export const updateCarFareSuccess = (payload: { fareData: FareInterface }) =>
  action(FaresTypes.UPDATE_CAR_FARE_SUCCESS, payload);
export const updateCarFareFailure = () =>
  action(FaresTypes.UPDATE_CAR_FARE_FAILURE);

// Delete Fare
export const deleteFareRequest = (payload: object) =>
  action(FaresTypes.DELETE_FARE_REQUEST, payload);
export const deleteFareSuccess = () => action(FaresTypes.DELETE_FARE_SUCCESS);
export const deleteFareFailure = () => action(FaresTypes.DELETE_FARE_FAILURE);

// Delete Car Fare
export const deleteCarFareRequest = (payload: object) =>
  action(FaresTypes.DELETE_CAR_FARE_REQUEST, payload);
export const deleteCarFareSuccess = () =>
  action(FaresTypes.DELETE_CAR_FARE_SUCCESS);
export const deleteCarFareFailure = () =>
  action(FaresTypes.DELETE_CAR_FARE_FAILURE);

// Set Current Operation
export const setCurrentOperation = (payload: { operation: OperationTypes }) =>
  action(FaresTypes.SET_CURRENT_OPERATION, payload);

// Set Fare Selected
export const setFareSelected = (payload: { fareSelected: FareInterface }) =>
  action(FaresTypes.SET_FARE_SELECTED, payload);
